import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { config } from 'src/app/config';
import { DummyDataService } from 'src/app/Services/dummy-data.service';

@Injectable({
  providedIn: 'root'
})
export class DataRequestService {
  private apiUrl = `${config.baseUrl}supersee/v1/data-manage`;

  constructor(private http: HttpClient, private _dummyDataService: DummyDataService) { }

  createRequest(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/create-request`, payload);
  }

  getAllRequests(companyId: number): Observable<any> {
    if (this._dummyDataService.isDemoDataVisible) {
      return of({ success: true, data: [] });
    }
    return this.http.get(`${this.apiUrl}/get-request?company_id=${companyId}`);
  }

  getRequestById(id: number, companyId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/get-request/${id}?company_id=${companyId}`);
  }

  cancelRequest(id: number, companyId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/cancel-request/${id}?company_id=${companyId}`);
  }

  deleteRequest(id: number, companyId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/delete-request/${id}?company_id=${companyId}`);
  }

  getScreenshotStats(companyId: number): Observable<any> {
    if (this._dummyDataService.isDemoDataVisible) {
      return of({
        success: true,
        data: {
          total_screenshots: 0,
          current_month_screenshots: 0,
          total_usage_seconds: 0,
          total_idle_seconds: 0,
          total_seconds: 0,
          total_hours_tracked: 0
        }
      });
    }
    return this.http.get(`${this.apiUrl}/statistics?company_id=${companyId}`);
  }
}

